// Port of api/fuel/app/classes/controller/api/monty/buddies/ratings.php
import F from 'offline/filter/constants'
import RatingsFilter from 'offline/filter/ratings'
import { runFilterEndpoint } from 'offline/api/monty'

export default function(params) {
	return runFilterEndpoint(RatingsFilter, params, F.OWNER_BUDDIES)
}
